import React from 'react'

const WelcomeDiv = () => {
  return (
    <>
    {/* <!--            User Welcome Div starts --> */}
				<div className="ad-dash-s1">
					<div className="cd-cen-intr-inn">
						<h2>Hi Welcome <b>Bizbook Directory Template</b></h2>
						<p>Stay up to date reports in your listing, products, events and blog reports here</p>
					</div>
				</div>
				{/* <!--            User Welcome Div ends --> */}
    </>
  )
}

export default WelcomeDiv